// extracted by mini-css-extract-plugin
module.exports = {"intro":"_1C5iYM5brUuXppg_sxc63w","heading":"_3fbjkFtEHEC6ye5QgD3_sK","text":"_2KmQU6cNqofQN-DA268BrK"};